/*
 * @Author: 俊昌 junchang.zhang@wahool.com
 * @Date: 2024-01-24 16:00:39
 * @LastEditors: 俊昌 junchang.zhang@wahool.com
 * @LastEditTime: 2024-01-25 18:12:41
 * @FilePath: /flowBusinessui/src/router/business/modules/integrated.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
export default {
  path: '/integrated',
  name: 'integrated',
  orderBy: 2,
  meta: {
    title: '集成'
  },
  component: () => import('@/views/home'),
  hidden: true,
  redirect: '/integrated/Amazon',
  children: [
    {
      path: 'Amazon',
      name: 'Amazon',
      meta: {
        title: 'Amazon',
        icon: 'fa fa-amazon',
        keepAlive: false,
        beforeEnter: true
      },
      hidden: true,
      component: () => import('@/views/integrated/index')
    },
    {
      path: 'Settings',
      name: 'Settings',
      meta: {
        title: 'Settings',
        icon: 'fa fa-cog',
        keepAlive: false,
        beforeEnter: true
      },
      hidden: false,
      component: () => import('@/views/integrated/settings/index')
    }
  ]
}
